import React, { useState } from "react";
import { X } from "lucide-react";
import { useCbomContext } from "../../context/CbomContext";
import UploadAgent from "../UploadAgent";
import DevicesUsingSensorAgent from "../DevicesUsingSensorAgent";
import ViewAgent from "../ViewAgent";

const ViewSensorAgent: React.FC = () => {
  const [activeButton, setActiveButton] = useState("view");
  const { setShowAgentViewForm } = useCbomContext();
  const handleClick = (buttonName: string) => {
    setActiveButton(buttonName);
  };
  return (
    <>
      <div className="h-full">
        <div
          className={
            "p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-hidden w-screen h-screen flex items-center justify-center"
          }
        >
          <div className="w-full p-2 bg-white rounded-lg flex flex-col h-full">
            <div className="flex justify-between items-center mb-4">
              <h1 className="text-xl font-bold text-custom-blue7 pl-2">
                View Sensor Agent
              </h1>
              <button
                className="p-2 bg-custom-blue7 rounded-full"
                onClick={() => {
                  setShowAgentViewForm(false);
                }}
              >
                <X size={20} className="text-gray-50" />
              </button>
            </div>
            <div className="flex flex-row justify-start w-full pl-2">
              <div className="space-x-2">
                <button
                  className={`px-6 py-2 rounded-t-md w-[150px] 
                      ${
                        activeButton === "view"
                          ? "bg-custom-blue8 text-custom-blue7"
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                  onClick={() => handleClick("view")}
                >
                  View
                </button>
                <button
                  className={`px-3 py-2 rounded-t-md w-[250px] 
                      ${
                        activeButton === "devicesUsingSensorAgent"
                          ? "bg-custom-blue8 text-custom-blue6"
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                  onClick={() => handleClick("devicesUsingSensorAgent")}
                >
                  Devices using  Sensor Agent
                </button>
              </div>
            </div>
            <div className="flex h-auto overflow-auto">
              {activeButton === "view" && <ViewAgent />}
              {activeButton === "devicesUsingSensorAgent" && <DevicesUsingSensorAgent />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSensorAgent;
